module.exports = __webpack_public_path__ + "static/img/google_paly.c6fbc3f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/google_paly.png
// module id = hb/p
// module chunks = 1